<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Company Details</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-row class="mb-2">
              <v-col cols="12" xs="12" sm="12" md="4">
                <v-text-field label="Company Name" v-model="record.Name" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="4">
                <v-text-field label="Email Address" v-model="record.Email" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="4">
                <v-text-field label="PIN No" v-model="record.PinNo" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="4">
                <v-text-field label="Tel 1" v-model="record.PhoneOne" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="4">
                <v-text-field label="Tel 2" v-model="record.PhoneTwo" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="4">
                <v-text-field label="Tel 3" v-model="record.PhoneThree" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="8">
                <v-text-field label="Physical Address" v-model="record.PhysicalAddress" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="4">
                <v-text-field label="P.O BOX" v-model="record.PostalAddress" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="4">
                <v-text-field label="Website" v-model="record.Website" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="4">
                <v-text-field label="Notification Email" v-model="record.NotificationEmail" outlined
                  dense></v-text-field>
              </v-col>

            </v-row>

            <v-row class="mt-2 mb-2">
              <v-col cols="12" xs="12" sm="12" md="4">
                <v-file-input v-model="logoFile" label="Browse Logo" outlined dense></v-file-input>
              </v-col>

              <!-- <v-col cols="12" xs="12" sm="12" md="4">
                <v-btn @click="deleteLogoDialog" class="float-right" icon><v-icon color="red">mdi-close</v-icon></v-btn>
                <v-img style="margin-top: 20px; width: 200px" :src="record.logo"></v-img>
              </v-col> -->

              <v-col cols="12" xs="12" sm="12" md="4">
                <span v-if="record.logoPath != ''" class="style-16" style="color: green"> Logo Uploaded </span>
                <span v-if="record.logoPath == ''" class="style-16" style="color: orange"> Logo Not Uploaded </span>
              </v-col>


            </v-row>


            <v-divider></v-divider>

            <v-row class="mt-2 mb-2">
              <v-col cols="12" xs="12" sm="12" md="12">
                <v-textarea v-model="record.LpoTerms" label="Lpo Terms" outlined dense rows="6"></v-textarea>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12">
                <v-textarea v-model="record.InvoiceTerms" label="Invoice Terms" outlined dense rows="6"></v-textarea>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12">
                <v-textarea v-model="record.DeliveryTerms" label="Delivery Terms" outlined dense rows="6"></v-textarea>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12">
                <v-textarea v-model="record.DealersIn" label="Dealers In" outlined dense rows="6"></v-textarea>
              </v-col>

            </v-row>

            <v-divider></v-divider>

            <v-row class="mt-2">
              <v-col cols="12" xs="12" sm="12" md="12">
                <v-btn class="primary" @click="save" :loading="loader">Update</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- logo dialog modal-->
    <v-dialog v-model="deleteDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="red" dark>
          <v-toolbar-title> Delete Logo </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="deleteDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row class="text--primary subtitle-2">
              <v-col cols="12"> Are you sure you want to delete Logo? </v-col>

              <v-col cols="12">
                <v-btn color="red" dark :loading="loader" @click="deleteLogo">Yes, Delete</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      record: {},
      deleteDialog: false,
      headerDialog: false,
      footerDialog: false,
      deleteItem: "",
      logoFile: null,
      footerFile: null,
      headerFile: null,
      loader: false,
    };
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  methods: {
    deleteLogoDialog() {
      this.deleteDialog = true;
    },
    deleteFooterDialog() {
      this.footerDialog = true;
    },
    deleteHeaderDialog() {
      this.headerDialog = true;
    },
    deleteLogo() {
      const data = this.record;
      const url = `/delete-logo`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
            self.loader = false;
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    save() {
      var subscriberId = localStorage.getItem("subscriber_id");
      const data = new FormData();
      const self = this;
      data.append("SubscriberId", subscriberId);
      data.append("store_id", parseInt(this.activeStore));
      data.append("logo", this.logoFile);
      data.append("PinNo", this.record.PinNo);
      data.append("PhoneOne", this.record.PhoneOne);
      data.append("PhoneTwo", this.record.PhoneTwo);
      data.append("PhoneThree", this.record.PhoneThree);
      data.append("Name", self.record.Name);
      data.append("Email", self.record.Email);
      data.append("PhysicalAddress", this.record.PhysicalAddress);
      data.append("PostalAddress", this.record.PostalAddress);
      data.append("Website", this.record.Website);
      data.append("NotificationEmail", this.record.NotificationEmail);
      data.append("LpoTerms", this.record.LpoTerms);
      data.append("InvoiceTerms", this.record.InvoiceTerms);
      data.append("DeliveryTerms", this.record.DeliveryTerms);
      data.append("DealersIn", this.record.DealersIn);

      // const data = this.record;
      self.loader = true;
      const url = "/company-details";
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.getGenSettings();
            this.$refs.snackbar.show("company details updated successfully", "green");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.loader = false;
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/company-details`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.record = { ...res.ResponseData };
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getGenSettings();
  },
};
</script>

<style lang="scss" scoped></style>